module.exports = __webpack_public_path__ + "img/defense-2011-doctor-2.f0218bbe.jpg";